import {ElementUtil} from '../../utils/elementUtil.js';
import {getMigrationOptionSummaryLines} from './migrationOptionFields.js';

var MIGRATION_STEP_ORDER = [
	'Initializing',
	'Validate Environment',
	'Migrate Billing Setup',
	'Migrate Billing History',
	'Migrate Users',
	'Migrate Units',
	'Migrate Company Config',
	'Migrate Operational Data',
	'Migrate Integrations',
	'Migrate Reports',
	'Cleanup Inactive Tractors',
	'Completing Migration'
];

function migrationStepSortKey(stepName) {
	if (!stepName) {
		return MIGRATION_STEP_ORDER.length + 1;
	}
	var index = MIGRATION_STEP_ORDER.indexOf(stepName);
	return index >= 0 ? index : MIGRATION_STEP_ORDER.length;
}

export function sortMigrationMessages(messages) {
	return (messages || []).slice().sort(function(left, right) {
		var stepDiff = migrationStepSortKey(left.batchStepName) - migrationStepSortKey(right.batchStepName);
		if (stepDiff !== 0) {
			return stepDiff;
		}
		var leftEntity = left.entityTypeDescription || left.entityType || '';
		var rightEntity = right.entityTypeDescription || right.entityType || '';
		// Step summary rows (no entity) first within a step, then entity/data detail rows
		if (!leftEntity && rightEntity) {
			return -1;
		}
		if (leftEntity && !rightEntity) {
			return 1;
		}
		return 0;
	});
}

export function showMigrationStatusDialog(record, migrationService, onRefresh) {
	var dialog = ElementUtil.create({
		tag: 'dl-dialog',
		title: 'Migration Status',
		icon: 'vaadin:info-circle',
		width: .75,
		height: .7,
		listeners: {
			ready: function() {
				dialog.show();

				var optionLines = getMigrationOptionSummaryLines(record).map(function(line) {
					return {
						tag: 'div',
						trustedInnerHTML: true,
						innerHTML: '<strong>' + line.label + ':</strong> ' + line.value
					};
				});

				var header = ElementUtil.create({
					tag: 'div',
					slot: 'toolbar',
					children: [
						{tag: 'div', trustedInnerHTML: true, innerHTML: '<strong>V6:</strong> ' + (record.v6CompanyName || '')},
						{tag: 'div', trustedInnerHTML: true, innerHTML: '<strong>V8:</strong> ' + (record.companyName || '')},
						{tag: 'div', trustedInnerHTML: true, innerHTML: '<strong>Step:</strong> ' + (record.migrationPhaseDescription || '')},
						{tag: 'div', trustedInnerHTML: true, innerHTML: '<strong>Status:</strong> ' + (record.runStatusDescription || '')},
						{tag: 'div', style: 'margin-top: 8px;', trustedInnerHTML: true, innerHTML: record.migrationPhase === 'COMPLETE'
							? 'This migration is complete. Further changes must be handled manually via the company or an admin.'
							: 'Migration is in progress or awaiting batch completion.'},
						{
							tag: 'vaadin-details',
							style: 'margin-top: 8px;',
							summary: 'Migration options',
							properties: {opened: false},
							children: [{
								tag: 'div',
								style: 'padding: 4px 0 0 8px;',
								children: optionLines
							}]
						},
						{
							tag: 'vaadin-button',
							theme: 'primary',
							style: 'margin-top: 8px;',
							children: [ElementUtil.makeIcon('vaadin:download', ' Download Full Log')],
							listeners: {
								click: function() {
									migrationService.downloadMigrationMessages(record.migrationId);
								}
							}
						}
					]
				});

				var messageGrid = ElementUtil.create({
					tag: 'vaadin-grid',
					theme: 'row-stripes column-borders',
					style: 'height: 100%;',
					slot: 'primary',
					defaults: {
						tag: 'vaadin-grid-sort-column',
						resizable: true
					},
					children: [
						{path: 'messageTypeDescription', header: 'Type', width: '110px', 'flex-grow': '0'},
						{path: 'batchStepName', header: 'Step', width: '180px', 'flex-grow': '0'},
						{path: 'entityTypeDescription', header: 'Entity', width: '150px', 'flex-grow': '0'},
						{path: 'message', header: 'Message', 'flex-grow': '1'}
					]
				});

				var layout = ElementUtil.create({
					tag: 'dl-flex-layout',
					children: [
						header,
						messageGrid
					]
				});
				dialog.addToContentElement(layout);

				var loadMask = messageGrid.showLoading();
				migrationService.getMigrationMessages(record.migrationId).then(function(messages) {
					messageGrid.items = sortMigrationMessages(messages.data || []);
				}).finally(function() {
					loadMask.remove();
				});
			}
		}
	});
}
